import { getJson, postJson, putJson, deleteJson, withDone, withValidate } from '@rad/utility/http';
export const getBanners = () => getJson(`/api/banners`);
export const getActiveBanners = () => getJson(`/api/banners/active`);
export const getBannerVariants = () => getJson(`/api/banners/variants`);
export const getBanner = (id) => getJson(`/api/banners/${id}`);
export const createBanner = (banner) => withDone(withValidate(postJson(`/api/banners`, banner)))();
export const updateBanner = (id, banner) => withDone(withValidate(putJson(`/api/banners/${id}`, banner)))();
export const deleteBanner = (id) => withDone(deleteJson(`/api/banners/${id}`))();
